import { render, staticRenderFns } from "./BasicParameters.vue?vue&type=template&id=ec018ce2&scoped=true&"
import script from "./BasicParameters.vue?vue&type=script&lang=ts&"
export * from "./BasicParameters.vue?vue&type=script&lang=ts&"
import style0 from "./BasicParameters.vue?vue&type=style&index=0&id=ec018ce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec018ce2",
  null
  
)

export default component.exports